var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _class2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import CatalogFragment from '@square/dashboard-items-data/models/connect/catalog-fragment';
import { attr } from '@ember-data/model';
import { fragment, fragmentArray, array } from 'ember-data-model-fragments/attributes';
import { CatalogCategoryType as CatalogCategoryTypeProto } from '@square/dashboard-protos/models/squareup/connect/v2/catalog/resources/enums';
export let CATEGORY_TYPE = /*#__PURE__*/function (CATEGORY_TYPE) {
  CATEGORY_TYPE["REGULAR_CATEGORY"] = "REGULAR_CATEGORY";
  CATEGORY_TYPE["MENU_CATEGORY"] = "MENU_CATEGORY";
  CATEGORY_TYPE["KITCHEN_CATEGORY"] = "KITCHEN_CATEGORY";
  return CATEGORY_TYPE;
}({});
export let NUMERIC_CATEGORY_TYPE = /*#__PURE__*/function (NUMERIC_CATEGORY_TYPE) {
  NUMERIC_CATEGORY_TYPE["REGULAR_CATEGORY"] = "1";
  NUMERIC_CATEGORY_TYPE["MENU_CATEGORY"] = "2";
  NUMERIC_CATEGORY_TYPE["KITCHEN_CATEGORY"] = "3";
  return NUMERIC_CATEGORY_TYPE;
}({});
let Data = (_dec = attr('string'), _dec2 = attr('number'), _dec3 = attr('string'), _dec4 = attr('string'), _dec5 = attr('string', {
  protoEnum: CatalogCategoryTypeProto,
  defaultValue: CATEGORY_TYPE.REGULAR_CATEGORY
}), _dec6 = attr('boolean'), _dec7 = attr('boolean'), _dec8 = attr('number', {
  defaultValue: 0
}), _dec9 = attr('number', {
  defaultValue: 0
}), _dec10 = attr('string'), _dec11 = attr('boolean'), _dec12 = array(), _dec13 = fragment('connect/category/membership'), _dec14 = fragmentArray('connect/category/location-override'), _dec15 = fragment('connect/category/ecom-seo-data'), _dec16 = fragment('connect/category/open-graph-data'), _dec17 = fragmentArray('connect/channel-integrations'), _class = (_class2 = class Data extends CatalogFragment {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "name", _descriptor, this);
    _initializerDefineProperty(this, "ordinal", _descriptor2, this);
    _initializerDefineProperty(this, "abbreviation", _descriptor3, this);
    _initializerDefineProperty(this, "labelColor", _descriptor4, this);
    _initializerDefineProperty(this, "categoryType", _descriptor5, this);
    _initializerDefineProperty(this, "isTopLevel", _descriptor6, this);
    _initializerDefineProperty(this, "onlineVisibility", _descriptor7, this);
    _initializerDefineProperty(this, "itemCount", _descriptor8, this);
    _initializerDefineProperty(this, "categoryCount", _descriptor9, this);
    _initializerDefineProperty(this, "rootCategory", _descriptor10, this);
    _initializerDefineProperty(this, "migratedFromSquareOnline", _descriptor11, this);
    _initializerDefineProperty(this, "channels", _descriptor12, this);
    // array of site ids for now
    _initializerDefineProperty(this, "parentCategory", _descriptor13, this);
    _initializerDefineProperty(this, "locationOverrides", _descriptor14, this);
    _initializerDefineProperty(this, "ecomSeoData", _descriptor15, this);
    _initializerDefineProperty(this, "openGraphData", _descriptor16, this);
    _initializerDefineProperty(this, "channelIntegrations", _descriptor17, this);
  }
}, _defineProperty(_class2, "_modelNameForMigration", 'connect/category/data'), _class2), _descriptor = _applyDecoratedDescriptor(_class.prototype, "name", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "ordinal", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "abbreviation", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "labelColor", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "categoryType", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "isTopLevel", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "onlineVisibility", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "itemCount", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "categoryCount", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "rootCategory", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "migratedFromSquareOnline", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "channels", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "parentCategory", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "locationOverrides", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "ecomSeoData", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "openGraphData", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "channelIntegrations", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { Data as default };